<template>
    <DropFileZone
        :id="`${id}_publish_upload_file`"
        :files="formData.attach_files"
        @addFiles="addFiles"
        @removeFiles="removeFiles"
    />
</template>

<script setup>
    import {ref, defineProps} from 'vue'
    import DropFileZone from "@/components/DropFileZone.vue";

    const props = defineProps({
        form: {
            type: Object,
            default: {
                title: '',
                content: '',
                is_private: false,
                story_group_id: '',
                files: [],
                attach_files: [],
                detach_files: [],
                mention_ids: [],
                model: "project",
                model_id: "",
                latitude: 0,
                longitude: 0,
                location_name: '',
                address: ''
            }
        }
    })

    const formData = ref(props.form)

    function addFiles(files){
        for(let file of files) {
            formData.value.files.push(file)
            formData.value.attach_files.push(file)
        }
    }

    function removeFiles(index) {
        const fileToDelete = formData.value.attach_files.splice(index, 1)
        formData.value.detach_files?.push(fileToDelete[0]?.id)
        formData.value.files.splice(index, 1)
    }
</script>